import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tips",
  "use": "icon-tips-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-tips\">\r\n  <defs>\r\n    <style>\r\n      #icon-tips .cls-1 {\r\n        fill: #f05254;\r\n      }\r\n\r\n      #icon-tips .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <circle id=\"icon-tips_椭圆_987\" data-name=\"椭圆 987\" class=\"cls-1\" cx=\"12\" cy=\"12\" r=\"12\" />\r\n  <path id=\"icon-tips_感叹号\" class=\"cls-2\" d=\"M559.99,356.389a1.116,1.116,0,0,0,.991-1.21V348.21a1.011,1.011,0,1,0-1.982,0v6.969a1.117,1.117,0,0,0,.991,1.21h0Zm0.016,1.191a0.923,0.923,0,0,0-.7.354,1.4,1.4,0,0,0,0,1.712,0.874,0.874,0,0,0,1.4,0,1.408,1.408,0,0,0,0-1.712,0.925,0.925,0,0,0-.7-0.354h0Zm0,0\" transform=\"translate(-548 -341)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tips.svg
// module id = D4Qx
// module chunks = 127